import { useState } from "react";
import SearchFilterIcon from "../../assets/icons/search-filter";
import { FilterComponentProps, StatusFilterProps } from "../../interfaces/common";

export const FilterComponent = ({
  onChange,
  filterOptions,
  selectedFilter,
}: FilterComponentProps) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleStatusFilterChange = (option: string) => {
    let status: StatusFilterProps | null = null;

    switch (option) {
      case "Active":
        status = { label: "Active" };
        break;
      case "Inactive":
        status = { label: "Inactive"};
        break;
      case "Pending":
        status = { label: "Pending" };
        break;
      case "All":
      default:
        status = null;
    }

    onChange(status);
    setIsDropdownOpen(false);
  };

  return (
    <div className="relative inline-block text-left">
      <button
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        className="flex items-center justify-center p-2 text-gray-700 bg-gray-200 border rounded-md shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        aria-haspopup="true"
        aria-expanded={isDropdownOpen}
      >
        <SearchFilterIcon />
      </button>

      {isDropdownOpen && (
        <div className="absolute right-0 top-full z-40 mt-2 w-40 rounded-md border bg-white py-2 shadow-lg dark:border-gray-600 dark:bg-gray-700">
          <div className="flex flex-col gap-1 px-2">
            {filterOptions.map((option) => (
              <button
                key={option}
                className={`block px-4 py-2 text-sm text-left rounded-md capitalize whitespace-nowrap ${
                  selectedFilter === option
                    ? "bg-gray-100 dark:bg-gray-600 cursor-default"
                    : "hover:bg-gray-200 dark:hover:bg-gray-600"
                }`}
                onClick={() => handleStatusFilterChange(option)}
              >
                {option}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};